export default {"src":"/_next/static/media/ic-table-connector_inactive.f122a6b6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};